require('roc-slot/spingames');
require('roc-slot/common/feature-freespin');

require('./primary.js');
require('./free_pick.js');

require('./game.css');
require('./hd.css');
require('./mobile.css');
require('./free_pick.css');



/** WEBPACK FOOTER **
 ** ./public-src/game.js
 **/